<iframe class="slido" [src]="url | safe" height="100%" width="100%"></iframe>
